import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  private loginCalled = false;

  setLoginCalled(value: boolean) {
    this.loginCalled = value;
  }

  hasLoginBeenCalled(): boolean {
    return this.loginCalled;
  }
}
